var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useThemeStyle } from '../hooks/useThemeStyle';
export var DropdownMenu = createOverridableComponent('div', function (props, Component, ref) {
    var css = useThemeStyle('dropdownMenu', {
        minWidth: 200,
        bg: 'background',
        borderStyle: 'solid',
        borderColor: 'grey',
        borderWidth: 1,
    });
    return jsx(Component, __assign({ ref: ref }, props, { css: css }));
});
export var DropdownMenuItem = createOverridableComponent(function (props) { return (jsx("button", __assign({ type: "button", tabIndex: 0 }, props))); }, function (props, Component, ref) {
    var css = useThemeStyle('dropdownMenuItem', {
        py: 2,
        px: 3,
        cursor: 'pointer',
        display: 'block',
        width: '100%',
        fontSize: 2,
        lineHeight: 1.5,
        textAlign: 'left',
        textDecoration: 'none',
        outlineStyle: 'none',
        appearance: 'none',
        bg: 'background',
        borderStyle: 'none',
        color: 'text',
    });
    return jsx(Component, __assign({}, props, { ref: ref, css: css }));
});
//# sourceMappingURL=DropdownMenu.js.map